export const SendEmail = async (email: string) => {
  const rawResponse = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/users/newsletter`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    }
  );

  const content = rawResponse.json();

  return content;
};
